module.exports = __webpack_public_path__ + "img/mad-dog-jones-logo.d451ca96.svg";